import MessageMain from "./src/main.js";

const Message = {};
Message.install = function(Vue) {
  Vue.prototype.$message = MessageMain;
};
Message.use = MessageMain;

export default Message;
